import { render, staticRenderFns } from "./taxQuery.vue?vue&type=template&id=64eed889&scoped=true&"
import script from "./taxQuery.vue?vue&type=script&lang=js&"
export * from "./taxQuery.vue?vue&type=script&lang=js&"
import style0 from "./taxQuery.vue?vue&type=style&index=0&id=64eed889&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eed889",
  null
  
)

export default component.exports